import { gu2px } from '@ux/theme-utils';
import cssSides, { Side } from '@team-griffin/css-sides';

export default ({
  theme,
}) => {
  const {
    spacing,
    palette,
  } = theme;

  return {
    default: {
      root: {
        display: 'flex',
        minHeight: gu2px(13, spacing),
        ...cssSides('padding', Side.X, gu2px(3, spacing)),
        ...cssSides('padding', Side.Y, gu2px(2, spacing)),
        backgroundColor: '#ffffff',
        textAlign: 'center',
        flexDirection: 'column',
        overflow: 'hidden',
        borderColor: palette.grey11,
        borderWidth: 1,
        boxShadow: 'inset 0 0 0 1px #ffffff',
        transition: `
          box-shadow 0.3s ease-in-out,
          border-color 0.3s ease-in-out
        `,
      },
      domainName: {
        wordBreak: 'break-all',
        alignSelf: 'center',
        marginBottom: gu2px(1, spacing),
      },
      domainPurchase: {
        minHeight: 90,
        display: 'flex',
        flexDirection: 'column',
        flexWrap: 'wrap',
        whiteSpace: 'nowrap',
        alignItems: 'center',
        textAlign: 'center',
      },
      domainAction: {
        width: '100%',
        flex: 1,
        flexBasis: 'auto',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
      },
      domainPrices: {
        flex: 1,
        flexBasis: 'auto',
        minWidth: 200,
        ...cssSides('padding', Side.X, gu2px(2, spacing)),
        ...cssSides('margin', Side.Y, gu2px(1, spacing)),
      },
      legal: {
        ...cssSides('margin', Side.X, gu2px(3, spacing)),
        marginBottom: gu2px(2, spacing),
        color: palette.grey08,
      },
    },

    isMinSm: {
      root: {
        marginBottom: 0,
        flexDirection: 'row',
        textAlign: 'left',
        alignItems: 'center',
        flexWrap: 'wrap',
      },
      domainName: {
        flex: 1,
        flexBasis: 'auto',
        marginBottom: 0,
        ...cssSides('padding', Side.Y, gu2px(1, spacing)),
      },
      domainIcon: {
        marginBottom: 0,
      },
      domainPrices: {
        minWidth: 'auto',
        marginLeft: gu2px(1, spacing),
        ...cssSides('margin', Side.Y, 0),
        ...cssSides('padding', Side.X, 0),
      },
      domainPurchase: {
        ...cssSides('padding', Side.Y, gu2px(1, spacing)),
        marginTop: 0,
        textAlign: 'right',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-end',
        flexDirection: 'row',
        flexWrap: 'wrap',
        marginLeft: 'auto',
        minHeight: 'auto',
      },
      domainAction: {
        marginLeft: gu2px(2, spacing),
        marginTop: 0,
        width: 'auto',
        whiteSpace: 'nowrap',
      },
    },

    isMinMd: {
      root: {
        ...cssSides('padding', Side.X, gu2px(4, spacing)),
      },
      legal: {
        ...cssSides('margin', Side.X, gu2px(4, spacing)),
      },
    },

    inBasket: {
      root: {
        borderColor: palette.green01,
        boxShadow: `inset 0 0 0 1px ${palette.green01}`,
      },
    },

    unavailable: {
      root: {
        opacity: 0.4,
      },
    },

    unspun: {
      root: {
        opacity: 1,
      },
    },
  };
};
